import styled from 'styled-components';

import { NextPageWithLayout } from '../../layouts';
import { FAQSection } from '../PricingPageContent/PricingPageContent';

const Container = styled.div`
  width: 100%;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const QuotesPageContent: NextPageWithLayout = () => {
  return (
    <Container style={{ marginTop: 40 }}>
      <FAQSection />
    </Container>
  );
};

export default QuotesPageContent;
